import React, { useState, useEffect } from 'react'
import {
  Button,
  Modal,
  notification,
  Input,
  Switch,
  Select,
  Space,
  Upload
} from 'antd'
import axios from 'src/API/config'
import { API } from 'src/API'
import { DollarCircleTwoTone, UploadOutlined } from '@ant-design/icons'
import { useDictionariesStore } from 'src/store/dictionaries'

export const UpdateSubscriptionModal = ({ id, refresh, reqData }) => {
  const [api, contextHolder] = notification.useNotification()

  const { subscriptions } = useDictionariesStore((store) => store)

  const [status, setStatus] = useState('')
  const [subscriptionId, setSubscriptionId] = useState(null)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = async () => {
    try {
      const data = {
        status,
        subscription_id: subscriptionId
      }

      await axios.put(`${API.COMMON.usersEndpoint}/${id}`, data)

      await api.success({
        message: 'Update User',
        description: 'Success',
        placement: 'topRight'
      })
      setIsModalOpen(false)
    } catch (e) {
      await api.error({
        message: 'Update User',
        description: e?.response?.data?.message || 'Error',
        placement: 'topRight'
      })
    } finally {
      refresh()
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    setStatus(reqData?.status)

    if (reqData?.subscription?.data?.id) {
      setSubscriptionId(reqData?.subscription?.data?.id)
    }

  }, [id])

  const STATUS_OPTIONS = [
    { value: 'active', label: 'Active' },
    { value: 'disactive', label: 'Inactive' }
  ]

  return (
    <>
      {contextHolder}
      <Button type='primary' onClick={showModal}>
        {'Update user'}
      </Button>
      <Modal
        title={'Update user'}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={'Update'}
      >
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Status</p>
          <Select
            style={{ width: 200 }}
            value={status}
            onChange={setStatus}
            options={STATUS_OPTIONS}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Subscription</p>
          <Select
            style={{ width: 200 }}
            value={subscriptionId}
            onChange={setSubscriptionId}
            options={[ ...subscriptions, { value: null, label: 'Free' }]}
          />
        </div>
      </Modal>
    </>
  )
}
